// import { gql } from '@apollo/client';
import gql from 'graphql-tag';

export const FAVOURITE_REPORTS_QUERY = gql`
query FavouriteReports {
  userFavourites {
    id
    creationTime
    report {
      id
      segment {
        id
        name
      }
      capability {
        id
        name
      }
      region {
        id
        name
      }
      market {
        id
        name
      }
      personas {
        id
        name
      }
      solution {
        id
        name
      }
      title
      ownerName
      metrics {
        id
        name

      }

    }

  }
}
`;
export const RECENT_REPORTS_QUERY = gql`
query RecentReports {
  userRecentViews {
    id
    visitTime
    report {
        id
      segment {
        id
        name
      }
      capability {
        id
        name
      }
      region {
        id
        name
      }
      market {
        id
        name
      }
      personas {
        id
        name
      }
      solution {
        id
        name
      }
      title
      ownerName
      metrics {
        id
        metric {
          name
        }
      }
      tags {
        name
      }
    }
  }
}
`;

export const REPORT_ALL_DETAILS_QUERY = gql`
query ReportDetails($id: GlobalID!) {
  report(id: $id) {
    title
    ownerName
    segment {
      id
      name
    }
    capability {
      id
      name
    }
    region {
      id
      name
    }
    market {
      id
      name
    }
    personas {
      id
      name
    }
    solution {
      id
      name
      problemDescription
      processSupported
      solutionProvided
    }
    platform {
      name
      id
    }
    metrics {
      metric {
        name
      }
      id
    }
    customer {
      id
      name
    }
    product {
      id
      name
    }
    channel {
      id
      name
    }
    question {
      id
      title
    }
    insight {
      id
      title
    }
    devUrl
    prodUrl
    slug
    visitorCount
    usersMarkedFavouriteCount
  }
}
`;


export const EXECUTE_SEARCH_QUERY = gql`
  query ExecuteSearch(
    $cursor: String = "",
    $search: String = ""
    ) {
    executeSearch(
      first: 24,
      after: $cursor,
      search: $search
      ) {
      edges {
        node {
          id
          title
          ownerName
          segment {
            id
            name
          }
          capability {
            id
            name
          }
          region {
            id
            name
          }
          market {
            id
            name
          }
          personas {
            id
            name
          }
          solution {
            id
            name
          }
          metrics {
            metric {
              name
            }
            id
          }
          platform {
            name
            id
          }
          tags {
            name
            id
          }
          functionalArea {
            id
            name
          }
          customer {
            id
            name
          }
          product {
            id
            name
          }
          channel {
            id
            name
          }
          question {
            id
            title
          }
          insight {
            id
            title
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;



//Subscription related objects

export const FAVOURITE_REPORTS_SUBSCRIPTION = gql`
subscription FavoriteReports {
  joinFavouriteReportsChannel {
    data
    }
  }
`;


export const RECENT_REPORTS_SUBSCRIPTION = gql`
subscription RecentReports {
  joinRecentReportsChannel {
    data
  }
}
`;
